export default "__VITE_ASSET__CyUDezFY__"